import React, { useState, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import "../../screenCss/Dashboard.css";
import "../../screenCss/Parent.css";
import "../../components/ProfileComponent/ProfileComponent.css";
import LeftMenuTherapist from "../LeftMenuTherapist";
import { logout } from "../../actions/auth";
import Support from "../../Containers/Support/index.js";
import { logoutUser, startLoading, stopLoading } from "store/actions";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import HeaderDashboardTherapist from "../HeaderDashboardTherapist";
import TherapistSessions1 from "../../Containers/TherapistSessions1/TherapistSessions1";
import Clients from "../../Containers/Clients/Clients";
import Chats from "../../Containers/Chats/Chats";
import TherapistProfile from "../../Containers/TherapistProfile/TherapistProfile";
import TherapistSessions from "Containers/TherapistSessions";
import TherapistClientDetails from "Containers/TherapistClientDetails/TherapistClientDetails";
import TherapistCaseNotesDetails from "Containers/TherapistCaseNotesDetails/TherapistCaseNotesDetails";
import AllTasks from "Containers/All Tasks/AllTasks";
import TherapistEvents from "Containers/TherapistEvents/TherapistEvents";
import { fetchOnboardingStatus } from "../../actions/dataLoad";
import TherapistOnboardingModal from "./TherapistOnboardingModal";

export const THERAPIST_MY_SESSIONS = "THERAPIST_MY_SESSIONS";
export const THERAPIST_CHATS = "THERAPIST_CHATS";
export const THERAPIST_MY_CLIENTS = "MY_CLIENTS";
export const THERAPIST_EVENTS = "THERAPIST_EVENTS";
export const THERAPIST_MY_PROFILE = "THERAPIST_MY_PROFILE";
export const THERAPIST_CLIENT_PROFILE = "THERAPIST_CLIENT_PROFILE";
export const THERAPIST_CASENOTES = "THERAPIST_CASENOTES";  
export const THERAPIST_TASKS = "THERAPIST_TASKS";


export const TherapistDashboard = (props) => {
  const [activeComponent, setActiveComponent] = useState(THERAPIST_MY_SESSIONS);
  const [compressLeftmenu, setCompressLeftmenu] = useState(false);
  const userToken = useUserTokenSelector();
  const userInfo = useUserInfoSelector();
  const { categoryId } = userInfo;
  const dispatch = useDispatch();
  const history = useHistory();

  // Onboarding states
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useState(null);

  const handleLogout = () => {
    logout(userToken);

    logoutUser(dispatch);

    window.localStorage.removeItem("auth");

    history.push({
      pathname: "/signin",
      state: {
        loggedOutMessage: "You have been logged out. Please login again.",
      },
    });
  };


  useEffect(() => {
    const checkOnboarding = async () => {
      if (userToken) {
        try {
          const res = await fetchOnboardingStatus(userToken);
          if (res.data && !res.data.isComplete) {
            setOnboardingStatus(res.data);
            setShowOnboarding(true);
          }
        } catch (error) {
          console.error("Error checking onboarding status", error);
        }
      }
    };
    checkOnboarding();
  }, [userToken, userInfo.email]);

  useEffect(() => {
      if (props.routeProps && activeComponent !== "") {
        const { activeTab } = props.routeProps;
        if (!activeTab) {
          history.push("/dashboard/therapist/sessions");
          return;
        }
        setActiveComponent(activeTab);
      }
    }, [props.routeProps]);

  return (
    <div style={{ height: activeComponent === "chats" ? "100vh" : "auto" }}>
      <HeaderDashboardTherapist
        categoryId={categoryId}
        activeComponent={activeComponent}
        showSessions={() => {
          setActiveComponent(THERAPIST_MY_SESSIONS);
          history.push("/dashboard/therapist/sessions");
        }}
        showChats={() => {
          setActiveComponent(THERAPIST_CHATS);
          history.push("/dashboard/therapist/chats");
        }}
        showClients={() => {
          setActiveComponent(THERAPIST_MY_CLIENTS);
          history.push("/dashboard/therapist/clients");
        }}
        showEvents={() => {
          setActiveComponent(THERAPIST_EVENTS);
          history.push("/dashboard/therapist/events");
        }}
        showProfile={() => {
          setActiveComponent(THERAPIST_MY_PROFILE);
          history.push("/dashboard/therapist/profile");
        }}
        handleLogout={handleLogout}
      />
      <div className={activeComponent === "chats" ? "wholeapp c2capp b2bapp therapist" : "wholeapp c2capp b2bapp"}>
        <LeftMenuTherapist
          activeComponent={activeComponent}
          handleLogout={handleLogout}
          compressMenu={() => setCompressLeftmenu(!compressLeftmenu)}
          showSessions={() => {
            setActiveComponent(THERAPIST_MY_SESSIONS);
            history.push("/dashboard/therapist/sessions");
          }}
          showChats={() => {
            setActiveComponent(THERAPIST_CHATS);
            history.push("/dashboard/therapist/chats");
          }}
          showClients={() => {
            setActiveComponent(THERAPIST_MY_CLIENTS);
            history.push("/dashboard/therapist/clients");
          }}
          showEvents={() => {
            setActiveComponent(THERAPIST_EVENTS);
            history.push("/dashboard/therapist/events");
          }}
          showProfile={() => {
            setActiveComponent(THERAPIST_MY_PROFILE);
            history.push("/dashboard/therapist/profile");
          }}
        />
        <div className={activeComponent === THERAPIST_CHATS ? "right-app-stuff therapistChats" : "right-app-stuff"} style={{ paddingLeft: compressLeftmenu && "150px" }}>
          {(() => {
            switch (activeComponent) {
              case THERAPIST_MY_SESSIONS:
                return <TherapistSessions />;
              case THERAPIST_MY_CLIENTS:
                return <Clients />;
              case THERAPIST_CHATS:
                return <Chats />;
              case THERAPIST_EVENTS:
                return <TherapistEvents/>;
              case THERAPIST_MY_PROFILE:
                return <TherapistProfile />;
              case THERAPIST_CLIENT_PROFILE:
                return <Clients />;
              case THERAPIST_CASENOTES:
                return <TherapistCaseNotesDetails />;
              case THERAPIST_TASKS:
                return <AllTasks />;
              default:
                <></>
              }
          })()
          }
        </div>
      </div>
      {showOnboarding && (
        <TherapistOnboardingModal
          show={showOnboarding}
          status={onboardingStatus}
          userToken={userToken}
          userInfo={userInfo}
          onComplete={() => setShowOnboarding(false)}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
};

export default TherapistDashboard;